import { useTranslation } from 'react-i18next'

import { CircularProgress, Switch } from '@mui/material'
import { AuroraHeatPumpStatus } from '../enums'
import AuroraControl from './AuroraControl'

export interface AuroraHeatPumpStatusControlProps {
  value: AuroraHeatPumpStatus
  loading?: boolean
  disabled?: boolean
  onSubmit: (value: AuroraHeatPumpStatus) => Promise<void>
}

export default function AuroraHeatPumpStatusControl({
  value,
  loading = false,
  disabled = false,
  onSubmit
}: AuroraHeatPumpStatusControlProps) {
  const { t } = useTranslation('aurora')

  const isChecked = value === AuroraHeatPumpStatus.ON

  async function handleChange(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
    try {
      await onSubmit(checked ? AuroraHeatPumpStatus.ON : AuroraHeatPumpStatus.OFF)
    } catch {
      // Ignore the error.
    }
  }

  return (
    <AuroraControl
      label={t('heatPump')}
      value={isChecked ? t('on') : t('off')}
      loading={loading}
      disabled={disabled}
      control={
        loading ? (
          <CircularProgress size={24} sx={{ mr: 4 }} />
        ) : (
          <Switch color="success" checked={isChecked} onChange={handleChange} disabled={disabled} />
        )
      }
    />
  )
}
